import { DownloadClientButton } from 'components/common/DownloadButton';
import { useTranslation } from 'react-i18next';
import { isElectron } from 'utils/isElectron';
import {
  GuardedComponent,
  GuardedComponentOverlayContent,
  GuardedComponentProps,
} from './GuardedComponent';

export interface ClientComponentProps extends Omit<GuardedComponentProps, 'allowed' | 'message'> {
  hideOnWeb?: boolean;
  showDownloadButton?: boolean;
}

export function ClientComponent({
  fallback,
  hideOnWeb,
  mode,
  showDownloadButton = false,
  children,
}: ClientComponentProps) {
  const { t } = useTranslation();
  const message = t('featureRequiresApp', 'This feature requires the dj-play.it app');

  return (
    <GuardedComponent
      allowed={isElectron()}
      hide={hideOnWeb}
      fallback={fallback}
      mode={mode}
      message={message}
      overlayContent={
        <>
          <GuardedComponentOverlayContent message={message} />
          {showDownloadButton && <DownloadClientButton sx={{ mt: 2 }} />}
        </>
      }
    >
      {children}
    </GuardedComponent>
  );
}
